module.exports = __webpack_public_path__ + "img/course_img1.05b3eaed.png";